import { useState } from 'react';
import Modal from './Modal';

/**
 * "Preview — how learners see this …" modal with a Web / Phone toggle.
 * Shared by the Practice, Event and Group editors (Course has its own,
 * older copy of the same layout).
 *
 * Buttons and links inside the preview are disabled (pointer-events: none)
 * so clicking Register / Join / Buy can't navigate away from the editor or
 * create real enrollments. Audio / video players stay usable.
 */
export default function PreviewModal({ kind, onClose, children }) {
  const [device, setDevice] = useState('web');
  const frame = (
    <div className="preview-frame">{children}</div>
  );
  return (
    <Modal title={`Preview — how learners see this ${kind}`} width="min(1040px, 94vw)" onClose={onClose}>
      <style>{`
        .preview-frame button, .preview-frame a, .preview-frame input, .preview-frame textarea {
          pointer-events: none;
        }
      `}</style>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'center', alignItems: 'center', marginBottom: 14, flexWrap: 'wrap' }}>
        {['web', 'phone'].map((d) => (
          <button key={d} className={`btn btn-sm ${device === d ? 'btn-primary' : ''}`} onClick={() => setDevice(d)}>
            {d === 'web' ? '🖥 Web' : '📱 Phone'}
          </button>
        ))}
        <span style={{ fontSize: '0.75rem', color: 'var(--muted)' }}>Buttons are disabled in preview.</span>
      </div>
      {device === 'phone' ? (
        <div style={{ width: 390, maxWidth: '100%', margin: '0 auto', border: '1px solid var(--border)', borderRadius: 24, overflow: 'hidden', boxShadow: 'var(--shadow-card)', background: 'var(--bg, #f6f7fb)' }}>
          <div style={{ padding: 12 }}>{frame}</div>
        </div>
      ) : frame}
    </Modal>
  );
}
